enum SearchSource {
  ApplyFilters = 'ApplyFilters',
  DefaultSuggestion = 'DefaultSuggestion',
  Facet = 'Facet',
  Favorites = 'Favorites',
  InitialPageLoad = 'InitialPageLoad',
  Location = 'Location',
  Pagination = 'Pagination',
  RecentSearch = 'RecentSearch',
  SavedSearch = 'SavedSearch',
  SortBy = 'SortBy',
  TagRemoved = 'TagRemoved',
  TextSearch = 'TextSearch',
  Tile = 'Tile'
}

export default SearchSource;
